import React from "react";
import { container_classname } from "./constants";
import Image from "next/image";
import { GBButton } from "./CTAButtons";

const metaItems = ["15th April 2026", "9.30 AM", "Meta office, Gurugram"];

const AIPowerOfNow = () => {
    return (
        <h1
            style={{
                display: "inline-block",
                lineHeight: 1.05,
                padding: "0.2em 0",
            }}
        >
            <span
                style={{
                    fontFamily: "Degular Display",
                    fontWeight: "100",
                    fontSize: "clamp(3.5rem, 6vw, 5rem)",
                    color: "#e8eaf0",
                    letterSpacing: "-0.01em",
                    display: "block",
                    marginBottom: "0.02em",
                }}
            >
                AI and the
            </span>
            <span
                style={{
                    fontFamily: "Degular Display",
                    fontWeight: "700",
                    fontSize: "clamp(3.5rem, 8.5vw, 6.5rem)",
                    lineHeight: 0.95,
                    background: "linear-gradient(180deg, #ffffff 0%, #ffffff 18%, #dce8ff 35%, #90b4ef 58%, #4d7de0 78%, #2a50c8 100%)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    backgroundClip: "text",
                    display: "block",
                    whiteSpace: "nowrap",
                }}
            >
                Power of Now
            </span>
        </h1>
    );
};

const EventHeroSection: React.FC = () => {
    return (
        <section
            className="overflow-hidde text-white"
            style={{
                backgroundImage: "url('https://assets.gallabox.com/gb-home/meta-event-assets/meta-event-hero-background.png')",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                backgroundSize: "cover",
            }}
        >
            <div className={`${container_classname} flex flex-col lg:flex-row  gap-12 py-16 md:py-24 lg:min-h-[720px] lg:items-center lg:justify-between lg:gap-16 lg:py-28`}>
                <div className="lg:w-1/2 max-w-[640px]">
                    <Image
                        src="https://assets.gallabox.com/gb-home/meta-event-assets/meta-and-gallabox-logo.svg"
                        alt="Meta Event 26"
                        width={259}
                        height={24}
                        className="inline-block "
                    />
                    <div
                        className="flex items-center uppercase text-sm md:text-md font-semibold font-inter gap-x-2 mt-4 md:mt-8 relative top-2"
                        style={{ color: "rgba(127, 136, 163, 1)" }}
                    >
                        <p>Leadership event</p>
                        <span>•</span>
                        <p>By invite only</p>
                    </div>
                    <AIPowerOfNow />

                    <p className="mt-5 md:mt-8 text-md md:text-xl leading-6 md:leading-8 text-white font-inter">
                        The businesses that are winning today aren&apos;t necessarily louder. They are just smarter about every conversation. Come see how India&apos;s top service
                        businesses are going about it.
                    </p>

                    <div className="my-10 flex flex-wrap items-center gap-y-3 text-md md:text-lg font-medium font-inter text-white">
                        {metaItems.map((item, index) => (
                            <React.Fragment key={item}>
                                <span
                                    className={`${index > 0 ? "px-6" : ""} ${index == 0 ? "pr-6" : ""}`}
                                    style={{
                                        borderInline: index === 1 ? "1px solid rgba(127, 136, 163, 1)" : "none",
                                    }}
                                >
                                    {item}
                                </span>
                            </React.Fragment>
                        ))}
                    </div>

                    <GBButton href="#event-registration-form" className="w-fit rounded-lg font-inter">
                        Register Now
                    </GBButton>
                </div>

                <div className="lg:w-1/2 hidden lg:block">
                    <div
                        style={{
                            backgroundImage: "url('https://assets.gallabox.com/gb-home/meta-event-assets/meta-event-hero-image.png')",
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "center",
                            backgroundSize: "cover",
                            mixBlendMode: "screen",
                            height: "610px",
                            maxHeight: "610px",
                        }}
                    ></div>
                </div>
            </div>
        </section>
    );
};

export default EventHeroSection;
